<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>
      National Park Skadar Lake – life by the water, among vineyards and
      aromatic plants
    </h1>
    <!-- <div class='tourPic'>
      <img src='@/assets/placestogo/01/01.jpg'>
    </div> -->
    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <!-- <span class='fa-li'><img  src='@/assets/logo/lovcen-green.png'/></span>
      <a data-toggle='collapse' href='#tourDescription'><h4 class='titles'>Tour description</h4></a> -->
          <div class='' id=''>
            <p class='pasus'>
              Although a small country, a lot of natural phenomena in Montenegro
              are marked as the largest, the deepest or the highest. Skadar Lake
              is one of such examples as it is the largest lake in the Balkans.
            </p>
            <p class='pasus'>
              It developed as a result of tectonic movements in distant past to
              acquire today’s size and status of manifold protected area owing
              to different natural processes that followed later on. With the
              maximum surface of 540km2 (in the summer) and rich resources, it
              has notably determined the way of life in the area surrounding it,
              having remained for millenniums a prestige settling area which
              resulted in great many of cultural and historical monuments
              resting on its islands, its coast and wider surroundings.
              Illyrians, Greeks, Slovenes, the last thousand years of
              Montenegrin dynasty but also Ottomans, Venetians and
              Austro-Hungarian’s… all had left some traces and influenced the
              cultural heritage of Skadar Lake area.
            </p>
            <p class='pasus'>
              In 1983 Skadar Lake was proclaimed national park, it gained IBA
              status as the area of extraordinary importance for birds and got
              listed as RAMSAR wetland area of international importance.
            </p>
            <p class='pasus'>
              It is a home to about 270 bird species, 50 fish species and
              endemic species of green Skadar frog whilst in its coastal area
              the senses are overwhelmed with different scents of aromatic
              plants and herbs.
            </p>
            <p class='pasus'>
              During a boat cruise on mostly calm lake you will be impressed by
              meadows of yellow and white water lily and water chestnut with its
              unusual fruits.
            </p>
            <p class='pasus'>
              There are a number of lake islands, or small hills, the seats of
              significant medieval monasteries and fortresses built and fought
              about by Montenegrins and Ottomans.
            </p>
            <p class='pasus'>
              Some historians link Skadar Lake with the story of ancient Troia,
              thus it is not surprising that one Hollywood piece from sixties
              was recorded in its immediate surroundings.
            </p>
            <p class='pasus'>
              There are a number of fascinating villages and hamlets resting on
              its shores and in its hinterland, of specific position and
              architecture.
            </p>
            <p class='pasus'>
              And beside Skadar carp, bleak and eel, tasting the most famous of
              Montenegrin wines – Crmnica wine is a must for all lovers of good
              drinks. Is has been made by local families for centuries and it is
              highly probable that famous wines Zinfandel and Primitivo
              originate from Crmnica autochthonous varieties.
            </p>
            <p class='pasus'>
              Once a year, usually in December, in tiny town of Virpazar – the
              centre of lake’s life, there is a festival dedicated to wine and
              bleak which is the greatest traditional celebration of such kind
              in Montenegro.
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/01/01.jpg'),
          thumbnail: require('@/assets/placestogo/01/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/02.jpg'),
          thumbnail: require('@/assets/placestogo/01/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/03.jpg'),
          thumbnail: require('@/assets/placestogo/01/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/04.jpg'),
          thumbnail: require('@/assets/placestogo/01/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/05.jpg'),
          thumbnail: require('@/assets/placestogo/01/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/06.jpg'),
          thumbnail: require('@/assets/placestogo/01/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/07.jpg'),
          thumbnail: require('@/assets/placestogo/01/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/01/08.jpg'),
          thumbnail: require('@/assets/placestogo/01/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG1_SkadarLake.vue